
import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import { baseApi } from "@store/apis";

import type { ChallengeDetails, ChallengeDetailsRequest } from "./models";


const GetChallengeDetailsQuery = baseApi.injectEndpoints({
  endpoints: builder => ({
    GetChallengeDetails: builder.query({
      query: ({ challengeId }: ChallengeDetailsRequest) => ({
        url: "GetDetailsById",
        method: "POST",
        body: {
          userId: secureStorage.get<string>(StorageKeys.USER_ID) || "",
          challengeId,
        },
      }),
      providesTags: ["Challenges"],
      transformResponse: (response: ChallengeDetails) => response.result,
    }),
  }),
});

export const { useGetChallengeDetailsQuery } = GetChallengeDetailsQuery;
